import { useRef } from "react"
import gsap from "gsap"
import { useGSAP } from "@gsap/react"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { API } from "../../api/api"

gsap.registerPlugin(useGSAP, ScrollTrigger)


type BaseScreenImageType = {
    url: string
    alt: string
    containerClassName?: string
    imageClassName?: string
}
export default function BaseScreenImage(props:BaseScreenImageType) {
    const containerRef = useRef<HTMLElement>(null)

    useGSAP(
        () => {
            const el = containerRef.current
            if (!el) return

            gsap.fromTo(
                el,
                { maxWidth: "1248px" },
                {
                    maxWidth: "100vw",
                    ease: "none",
                    scrollTrigger: {
                        trigger: el,
                        start: "top 80%",
                        end: "bottom 95%",
                        scrub: true,
                    },
                }
            )
        },
        { scope: containerRef }
    )

    return (
        <section ref={containerRef} className={`mx-auto w-full overflow-hidden ${props.containerClassName ?? ""}`}>
            <img
                src={API.img + props.url}
                alt={props.alt}
                className={`w-full aspect-video xl:min-w-page object-cover ${props.imageClassName ?? "max-h-[90dvh] "}`}
            />
        </section>
    )
}
